import { Box, Stack } from '@mui/material';
import Report from 'modules/common/component/report';
import { REPORT_VIEW_MODE } from 'modules/common/component/report/consts';
import DebtReportChart from 'modules/common/page/report/business/debtReport/DebtReportChart';
import DebtReportTable from 'modules/common/page/report/business/debtReport/DebtReportTable';
import { useState } from 'react';

const EncounterReportTab = () => {
  const [viewMode, setViewMode] = useState<keyof typeof REPORT_VIEW_MODE>('CHART');
  return (
    <Report>
      <Stack direction="column" position="relative">
        <Stack direction="row" justifyContent="flex-end" position="absolute" top={-10} right={0}>
          <Report.SwitchLayout onChange={(viewMode) => setViewMode(viewMode)} defaultMode="CHART" />
        </Stack>
        <Box marginTop={1}>{viewMode === 'TABLE' ? <DebtReportTable /> : <DebtReportChart />}</Box>
      </Stack>
    </Report>
  );
};

export default EncounterReportTab;
